export interface Note {
  note: string;
  print: string;
}
